/* ==========================================================================
   CheckboxRxjs > Template
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');

const { prepareDataConfig } = require('@bluekiri/alexandria/helpers/dataHelpers');

const configuration = require('./client/js/config');

/**
 * CheckboxRxjs template
 * @param {object} data Object containing the data model for this component.
 * @param {object} context The general context object.
 * @returns {object} Additional data to have available in the template
 */
module.exports = function Template(data = {}) {
    /* Data */
    const { config = {}, label, checked = false, disabled = false, name } = data;
    const { styles = [] } = config;
    const { dataType } = prepareDataConfig(config.data);

    /* Template */
    return html(`
        <div class='${['checkbox-rxjs', ...styles].join(' ').trim('')}'
        data-component='${configuration().component}'
        ${dataType ? `data-type='${dataType}'` : ''}
        data-config='${JSON.stringify({
            ...config,
            disabled
        })}'>
        
            <input type='checkbox'
                ${name ? `name='${name}'` : ''}
                ${checked ? 'checked=""' : ''}></input>

            <label>${label}</label>
        </div>
    `);
};
